import React from 'react';
const IsRequired = () => React.createElement("span", { className: "text-danger" }, "* ");
export default IsRequired;
